import { Box, Paper, Typography } from "@material-ui/core";

export default function PaperWrapper({ title, children, paperProps, ...props }) {
  return (
    <Box {...props}>
      <Box pb={1}>
        <Typography variant="h4">{title}</Typography>
      </Box>
      <Paper {...paperProps}>{children}</Paper>
    </Box>
  );
}
